import { z } from "zod";
import { pageOf, pageQuerySchema } from "../common/pagination.js";
import { timestampSchema, uuidSchema } from "../common/primitives.js";
import { dataSubjectRequestChannelSchema, dataSubjectRequestStatusSchema, dataSubjectRequestTypeSchema, } from "./enums.js";
/**
 * İlgili kişi başvurusu (KVKK md. 11, ADR 0017 §9): `RECEIVED → IN_PROGRESS → COMPLETED | REJECTED`; son gün = alındığı
 * İstanbul günü + `KVKK_REQUEST_RESPONSE_DAYS` (mevzuat parametresi, varsayılan 30) gününün sonu. Veri dökümü JSON dosya
 * olarak depolamaya yazılır; silme başvurusunda kişisel veri kaydındaki TÜM işleyiciler tek transaction'da anonimleştirir.
 */
export const DEADLINE_STATES = ["OK", "DUE_SOON", "OVERDUE"];
export const deadlineStateSchema = z.enum(DEADLINE_STATES);
export const DEADLINE_STATE_LABELS = {
    OK: "Süresi var",
    DUE_SOON: "Son güne az kaldı",
    OVERDUE: "Süresi geçti",
};
export const dataSubjectRequestSchema = z.object({
    id: uuidSchema,
    requestNo: z.string(),
    customerProfileId: uuidSchema.nullable(),
    customerCode: z.string().nullable(),
    subjectName: z.string().describe("KVKK: başvuranın adı (maskeli olabilir)"),
    subjectContact: z.string().nullable().describe("KVKK: iletişim (maskeli olabilir)"),
    identityVerified: z.boolean(),
    requestType: dataSubjectRequestTypeSchema,
    channel: dataSubjectRequestChannelSchema,
    receivedAt: timestampSchema,
    dueAt: timestampSchema,
    deadlineState: deadlineStateSchema.describe("Açık başvuruda son güne göre durum; kapanmışsa OK"),
    status: dataSubjectRequestStatusSchema,
    description: z.string().describe("KVKK: başvuru metni (maskeli olabilir)"),
    response: z.string().nullable(),
    exportFileId: uuidSchema.nullable(),
    exportedAt: timestampSchema
        .nullable()
        .describe("Son veri dökümünün üretildiği an (dosyanın onay / oluşturma zamanı); döküm yoksa null"),
    anonymizedAt: timestampSchema.nullable(),
    completedAt: timestampSchema.nullable(),
    completedBy: uuidSchema.nullable(),
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
    version: z.number().int(),
    personalDataMasked: z.boolean(),
});
export const dataSubjectRequestPageSchema = pageOf(dataSubjectRequestSchema);
export const listDataSubjectRequestsQuerySchema = pageQuerySchema.extend({
    status: dataSubjectRequestStatusSchema.optional(),
    deadline: deadlineStateSchema.optional().describe("Yalnızca AÇIK başvurular: son güne göre"),
    requestType: dataSubjectRequestTypeSchema.optional(),
    customerProfileId: uuidSchema.optional(),
});
export const createDataSubjectRequestSchema = z.object({
    customerProfileId: uuidSchema.nullable().default(null).describe("Başvuran kayıtlı müşteriyse"),
    subjectName: z.string().trim().min(2).max(160).describe("KVKK: başvuranın adı"),
    subjectContact: z.string().trim().min(3).max(254).nullable().default(null).describe("KVKK: yanıt adresi"),
    identityVerified: z.boolean().default(false),
    requestType: dataSubjectRequestTypeSchema,
    channel: dataSubjectRequestChannelSchema,
    receivedAt: timestampSchema
        .optional()
        .describe("Başvurunun ulaştığı an (varsayılan: şimdi; ileri tarih olamaz)"),
    description: z.string().trim().min(5).max(4000),
});
export const dataSubjectRequestActionSchema = z.object({ version: z.number().int().positive() });
export const resolveDataSubjectRequestSchema = z.object({
    version: z.number().int().positive(),
    response: z.string().trim().min(5, "Yanıt en az 5 karakter olmalıdır").max(4000),
});
export const anonymizeResultSchema = z.object({
    request: dataSubjectRequestSchema,
    affectedRecords: z
        .number()
        .int()
        .describe("İşleyicilerin anonimleştirdiği kayıt sayısı (tekrar çağrıda 0)"),
    modules: z.array(z.object({ module: z.string(), affected: z.number().int() })),
});
//# sourceMappingURL=requests.js.map